import React from 'react';
import TiktokOrderListPage from '@/tiktok-platform/modules/aftersales/OrderListPage';

/** 订单根路径：统一进入订单列表（不做履约发货分流）。 */
export default function TiktokOrdersIndexRedirect() {
  return <TiktokOrderListPage />;
}
